import { FormEmbedSliceData } from '@adapters/prismic/types/slices';
import DOMPurify from 'isomorphic-dompurify';
import styles from './FormEmbed.module.scss';

const FormEmbed = ({ html }: FormEmbedSliceData) => {
  const cleanHtml = DOMPurify.sanitize(html);
  return (
    <div className={styles.formContainer}>
      <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />
    </div>
  );
};

export default FormEmbed;
